import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { kmMessages } from "src/constant/Messages";
import { Skeleton } from "@material-ui/lab";
import { Alert, AlertTitle } from "@material-ui/lab";
import renderHTML from "react-render-html";
import { useForm, Controller } from "react-hook-form";
import Autocomplete from "@material-ui/lab/Autocomplete";

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  radiogrp: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
}));

const Form = ({ onSubmit, voting, entryId, ...rest }) => {
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = useState();
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (voting?.selectedVotingOptionId) {
      setSelectedValue(voting.selectedVotingOptionId.toString());
    }
    return () => {};
  }, [voting]);

  const { handleSubmit, setValue, control, errors } = useForm();

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const onSubmitLocal = (values) => {
    onSubmit(voting.id, parseInt(selectedValue), values.user.userId);
  };

  return (
    <Card className={clsx(classes.root)} {...rest}>
      <Box component="main">
        <Grid container className={classes.root}>
          <Grid item xs={12}>
            <form onSubmit={handleSubmit(onSubmitLocal)}>
              <Box pb={2}>
                <Alert severity="warning" className={classes.kmmessage}>
                  <AlertTitle>
                    <strong>Uwaga! Głosowanie w imieniu uzytkownika</strong>
                  </AlertTitle>
                  <div>
                    {voting?.general
                      ? renderHTML(
                          "<p>Głosujesz w imieniu użytkownika. Zapis oznacza nadpisanie głosu użytkownika jeśli głos został wcześniej oddany.</p> "
                        )
                      : renderHTML(
                          "<p>Głosujesz w imieniu użytkownika. Zapis oznacza nadpisanie głosu użytkownika jeśli głos został wcześniej oddany.</p><br><p>Jeśli w danej instytucji głos oddał inny uzytkownik, głos ten również zostanie anulowany.</p> "
                        )}
                  </div>
                </Alert>
              </Box>

              {voting ? (
                <Box>
                  <FormControl
                    component="fieldset"
                    className={classes.formcontrol}
                    onChange={handleChange}
                    fullWidth
                  >
                    <Controller
                      render={({ onChange, ...props }) => (
                        <Autocomplete
                          id="user-id"
                          options={voting.voteUsers}
                          getOptionLabel={(option) => option.userFullName}
                          getOptionSelected={(option, value) =>
                            value && option.userId === value.userId
                          }
                          value={props.value}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={errors.user ? true : false}
                              label="Użytkownik"
                              placeholder="Użytkownik"
                              onChange={(e, data) => onChange(data)}
                              helperText={
                                errors.user &&
                                (formValidation[errors.user.type] || "")
                              }
                            />
                          )}
                          onChange={(e, data) => onChange(data)}
                        />
                      )}
                      onChange={([, data]) => data}
                      name="user"
                      control={control}
                      rules={{ required: true }}
                      defaultValue={selectedUser}
                    />
                  </FormControl>

                  <FormControl
                    component="fieldset"
                    className={classes.formcontrol}
                    onChange={handleChange}
                  >
                    <FormLabel component="legend">{voting.title}</FormLabel>
                    <RadioGroup
                      aria-label="vote"
                      name="vote"
                      className={classes.radiogrp}
                    >
                      {voting.votingOptions.map((votingOption) => {
                        return (
                          <FormControlLabel
                            checked={
                              selectedValue === votingOption.id.toString()
                            }
                            key={votingOption.id}
                            value={votingOption.id.toString()}
                            control={<Radio color="primary" />}
                            label={votingOption.name}
                          />
                        );
                      })}
                    </RadioGroup>
                  </FormControl>
                </Box>
              ) : (
                <Skeleton />
              )}

              <Box className={classes.paddingtop}>
                <Button
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={`/zarzadzanieglosowania/podgladglosowania/${entryId}`}
                >
                  Zamknij
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.button}
                  endIcon={<SaveIcon />}
                  type="submit"
                >
                  Zapisz
                </Button>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default Form;
